<div fxLayout="row" fxLayoutAlign="end center" class="u-height-100">
  <button
    (click)="actioned(headerAction)"
    mat-raised-button
    [color]="headerAction.color"
  >
    <span i18n="@@settingsView.headerAction">{headerAction.text, select,
      other {{{ headerAction.text }}}
    }</span>
  </button>
</div>
